import { Empty } from 'antd';
import React from 'react';

const Policies = () => {
  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '30px',
        }}
      >
        <p>
          <Empty />
        </p>
      </div>
    </React.Fragment>
  );
};

export default Policies;
